import moment from 'moment';

export const Invoice = (data, printContent) => {
   //  const getQTY = data.orderedProducts.reduce((sum, cur) => {
   //     return sum + cur.qty;
   //  }, 0);

   return `<div style="font-family: Arial, sans-serif; width: 100%;  margin: 0; padding: 0">
  <div style="padding: 5px; box-sizing: border-box">
    <div style="text-align: center; margin-bottom: 10px">
     <h2 style="margin: 5px 0; font-size: 14px">MA HOUSE LTD</h2>
     <h2 style="margin: 5px 0; font-size: 14px; font-weight: bold">Repairing Payment Recipe</h2>
    </div>
    <hr style="border-top: 1px dotted #000; border-bottom: none;" />
    <table style="width: 100%; border-collapse: collapse; font-size: 12px">
      <tbody>
         <tr>
          <td style="text-align: left; padding: 3px">Date:</td>
          <td style="text-align: right; padding: 3px">${moment(data.createdAt).format('DD-MM-YYYY hh:mm')}</td>
        </tr>
        <tr>
          <td style="text-align: left; padding: 3px">Name:</td>
          <td style="text-align: right; padding: 3px">${data?.customerName}</td>
        </tr>
        <tr>
          <td style="text-align: left; padding: 3px">Invoice No:</td>
          <td style="text-align: right; padding: 3px">${data.invoiceId}</td>
        </tr>
        <tr>
          <td style="text-align: left; padding: 3px">Payment Method:</td>
          <td style="text-align: right; padding: 3px; font-size: 16px; font-weight: 600">${data.paymentMethod}</td>
        </tr>
      </tbody>
    </table>
    <hr style="border-top: 1px dotted #000; border-bottom: none;" />
    <table style="width: 100%; border-collapse: collapse; font-size: 12px">
      <thead>
        <tr>
          <th style="text-align: left; padding: 5px">Item</th>
          <th style="text-align: right; padding: 5px">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th style="text-align: left; padding: 5px">${data?.makeModal}</th>
          <th style="text-align: right; padding: 5px">${data?.amount}</th>
        </tr>
        <tr>
          <td colspan="3" style="font-weight: 600; text-align: right">Total Qty: ${data?.amount}</td>
        </tr>
      </tbody>
    </table>
  ${
     data?.network
        ? `
     <hr style="border-top: 1px dotted #000; border-bottom: none;" />
     <div style="padding: 5px">Note: ${data.network}</div>
    `
        : ''
  }
   <hr style="border-top: 1px dotted #000; border-bottom: none;" />
    <div style="display:flex; justify-content:center">
      ${printContent}
    </div>
    <div style="padding-top: 10px; text-align: center">
      <p style="font-size: 16px">Thank you for shopping with us</p>
    </div>
    <hr style="border-top: 1px dotted #000; border-bottom: none;" />
  </div>
</div>
`;
};
